import { domClientWidth } from "$md-base-tools/env";
import { ElMessage, ElMessageBox } from 'element-plus'
/* eslint-disable */
const tools = {
    addbind(element, type, handler) {
        if (element.addEventListener) {
            element.addEventListener(type, handler, false)
        } else if (element.attachEvent) {
            element.attachEvent("on" + type, handler)
        } else {
            element["on" + type] = handler
        }
    },
    removebind(element, type, handler) {
        if (element.removeEventListener) {
            element.removeEventListener(type, handler, false)
        } else if (element.detachEvent) {
            element.detachEvent("on" + type, handler)
        } else {
            element["on" + type] = null
        }
    },
    hasClass(obj, cls) {
        let obj_class_lst = obj.className.split(/\s+/)
        return obj_class_lst.some(ele => {
            return ele === cls
        })
    },
    addClass(obj, cls) {
        if (!this.hasClass(obj, cls)) {
            let obj_class = obj.className,
                cls_place = obj_class != "" ? " " : ""
            obj.className = obj_class + cls_place + cls
        }
    },
    removeClass(obj, cls) {
        if (this.hasClass(obj, cls)) {
            let obj_class = " " + obj.className + " "
            obj_class = obj_class.replace(/(\s+)/gi, " ")
            let hold_class = obj_class.replace(" " + cls + " ", " ")
            hold_class = hold_class.replace(/(^\s+)|(\s+$)/g, "")
            obj.className = hold_class
        }
    },
    siblings(obj) {
        let nodes = [],
            than = obj
        while ((obj = obj.previousSibling)) {
            if (obj.nodeType === 1) {
                nodes.push(obj)
                break
            }
        }
        obj = than
        while ((obj = obj.nextSibling)) {
            if (obj.nodeType === 1) {
                nodes.push(obj)
                break
            }
        }
        return nodes
    },
    // 警告提示 - 黄色
    toast(message) {
        ElMessage({
            type: 'warning',
            customClass: 'waring-customize',
            message: message,
        });
    },
    // 错误提示-黑色
    toastNext(message) {
        ElMessage({
            type: 'info',
            customClass: 'info-customize',
            message: message,
          });
    },
    confirm(args, callBack, cancelBack) {
        let msg = "",
            success = "确定",
            cancel = "取消",
            title = "",
            align = "",
            hasCancel = true,
            showClose = true,
            distinguishCancelAndClose = true,
            dangerouslyUseHTMLString = false
        if (domClientWidth() > 780) {
            title = "提示"
        }
        if (typeof args === "object") {
            if (args.title) title = args.title
            if (args.msg) msg = args.msg
            if (args.success) success = args.success
            if (args.cancel) cancel = args.cancel
            if (args.align) align = args.align
            if (args.hasCancel) hasCancel = args.hasCancel
            if (args.showClose) showClose = args.showClose
            if (args.dangerouslyUseHTMLString) dangerouslyUseHTMLString = args.dangerouslyUseHTMLString
            if (args.distinguishCancelAndClose) distinguishCancelAndClose = args.distinguishCancelAndClose
        } else {
            if (args) msg = args
        }
        if (args.cancel){
            ElMessageBox.confirm(msg, title, {
                autofocus: false,
                distinguishCancelAndClose:distinguishCancelAndClose,
                cancelButtonText: cancel,
                confirmButtonText: success,
                dangerouslyUseHTMLString:dangerouslyUseHTMLString,
                showClose: showClose
              }).then(() => {
                if(typeof callBack === "function"){
                    callBack()
                }
              }).catch((action) => {
                if(action === 'cancel' && typeof cancelBack === "function"){
                    cancelBack()
                }
              })
        }else{
            ElMessageBox.alert(msg, title, {
                autofocus: false,
                confirmButtonText: success,
                dangerouslyUseHTMLString:dangerouslyUseHTMLString,
                showClose: showClose,
                callback: () => {
                    if(typeof callBack === "function"){
                        callBack()
                    }
                },
            })
        }
    },
    openWin: function(url, target) {
        if (!url) return false
        if (target) {
            let openWin = document.getElementById('openWin')
            openWin.setAttribute('target', target)
            openWin.setAttribute('href', url)
            openWin.children[0].click()
        } else {
            location.href = url
        }
    },
    gotoWin: function(url, msg) {
        if (msg) this.toast(msg)
        setTimeout(() => {
            this.openWin(url)
        }, 2000)
    },
    closeWin: function() {
        opener = null
        open('', '_self')
        close()
    },
    downLoadUrl: function(url, name) {
        if (url && name) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                if (this.status === 200) {
                    const blob = new Blob([this.response]);
                    // const blob = new Blob([this.response], { type : 'application/vnd.ms-excel' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = name;
                    document.body.appendChild(link);
                    link.click();
                }
            };
            xhr.send();
        }
    }
}

tools.includeLinkStyle = url => {
    let link = document.createElement("link")
    link.rel = "stylesheet"
    link.type = "text/css"
    link.href = url
    document.getElementsByTagName("head")[0].appendChild(link)
}

tools.dynamicScript = (url, callBack) => {
    let script = document.createElement('script')
    let head = document.getElementsByTagName('head')[0]
    script.type = "text/javascript"
    script.defer = true
    script.async = true
    script.src = url
    head.appendChild(script)
    if (typeof callBack === "function") {
        if (script.readyState) { //IE　　
            script.onreadystatechange = () => {
                if (/complete|loaded/.test(script.readyState)) {　　
                    script.onreadystatechange = null
                    callBack()
                }
            }
        } else {
            script.onload = () => {
                callBack()
            }
        }
    }
}
tools.dateFormat = (dateStr) => {
    if (typeof dateStr === 'string') {
        dataStr = dateStr.replace(/-/ig, '/');
    }
    var date = dateStr ? new Date(dateStr) : new Date();
    var year, month, day, result = [];
    year = date.getFullYear();
    month = date.getMonth() + 1 > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
    day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    // hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
    // minute = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
    // seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
    result.push(year, month, day);
    return result;
}
// 数据格式化-两位小数 
tools.fmoney = function (s, n) {
    let m = ''
    if (String(s).indexOf('-') !== -1) {
      m = '-'
      s = -Number(s)
    }
    n = String(s).indexOf('.') !== -1 ? 2 : (n || 0)
    s = String(parseFloat(String(s).replace(/[^\d\\.-]/g, '')).toFixed(n))
    var l = s.split('.')[0].split('').reverse()
    var r = s.indexOf('.') !== -1 ? '.' + s.split('.')[1] : ''
    var t = ''
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '')
    }
    return (m + t.split('').reverse().join('') + r)
}
// echarts y轴刻度格式化
tools.formatter = function(v) {
    v = v.toString()
    if (v >= 100000000000) {
        return (v.substring(0, 5) / 10) + '亿'
    } else if (v >= 10000000000) {
        return (v.substring(0, 4) / 10) + '亿'
    } else if (v >= 1000000000) {
        return (v.substring(0, 3) / 10) + '亿'
    } else if (v >= 100000000) {
        return (v.substring(0, 2) / 10) + '亿'
    } else if (v >= 10000000) {
        return v.substring(0, 4) + '万'
    } else if (v >= 1000000) {
        return v.substring(0, 3) + '万'
    } else if (v >= 100000) {
        return v.substring(0, 2) + '万'
    } else if (v >= 10000) {
        return (v.substring(0, 2) / 10) + '万'
    } else if (v >= 1000) {
        return tools.fmoney(v)
    } else {
        return v
    }
}
export default tools
export const debounce = (func, immediate, wait = 1000) => {
    let timer
    return function () {
        const context = this,
            args = arguments
        if (timer) clearTimeout(timer)
        if (immediate) {
            timer = setTimeout(() => {
                func.apply(context, args)
            }, wait)
        } else {
            const status = !timer
            timer = setTimeout(() => {
                timer = null
            }, wait)
            if (status) func.apply(context, args)
        }
    }
}
